import { ComparisonOperator as ComparisonOperators, ComparisonOperatorType } from 'cio/utils/operators';
import { ConditionType } from 'cio/utils/condition-types';

export enum ConditionEditorSubLayout {
  Stacked = 'stacked',
  Inline = 'inline',
}

export function removeEventComparisonOperator(items: ComparisonOperatorType[]): ComparisonOperatorType[] {
  return items.filter((operator) => operator.value !== ComparisonOperators.Event);
}

export function operatorsWithoutEventTypes(value: ComparisonOperators): boolean {
  return ![ComparisonOperators.Event, ComparisonOperators.ForeignEventAttribute].includes(value);
}

export function valueAndEventOperatorsOnly(items: ComparisonOperatorType[]): ComparisonOperatorType[] {
  return items
    .filter((operator) => [ComparisonOperators.Value, ComparisonOperators.Event].includes(operator.value))
    .map((operator) => {
      if (operator.value === ComparisonOperators.Event) {
        return { ...operator, label: "the person's trigger attribute" };
      }
      return operator;
    });
}

export const duplicateableConditions = [
  ConditionType.Attribute,
  ConditionType.DeviceAttribute,
  ConditionType.Event,
  ConditionType.Form,
  ConditionType.PageView,
  ConditionType.Screenview,
  ConditionType.Email,
  ConditionType.Action,
  ConditionType.Relationship,
];
